/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceCountByAccount {
    getFixupPrototypeFunction() { return ResourceCountByAccount.fixupPrototype; }

    static newInstance(model: Partial<ResourceCountByAccount>): ResourceCountByAccount {
        let obj = Object.assign(new ResourceCountByAccount(), model);
        ResourceCountByAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceCountByAccount>): ResourceCountByAccount {
        if (!model) return null;
        return ResourceCountByAccount.newInstance(<ResourceCountByAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceCountByAccount) {
        if (!obj) return;

        models.ResourceCountByAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceCountByAccount): boolean {
        Object.setPrototypeOf(obj, ResourceCountByAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.open === undefined) {
            this.open = 0;
        }
    }

    /**
     * Resource count that are open
     */
    open: number;

}
